import React from "react";
import PropTypes from "prop-types";

import Group from "./Apparatus/group/Group"
import {Pipette} from "./Apparatus/Pipette"
import {TipBox} from "./Apparatus/TipBox"
import {Trash} from "./Apparatus/Trash"
import {Solution} from "./Apparatus/Solution"
//import {Microcentrifuge} from "./Apparatus/Microcentrifuge"
import {IceBucket} from "./Apparatus/IceBucket"
import {Thermocycler} from "./Apparatus/Thermocycler"
//import {HeatBlock} from "./Apparatus/HeatBlock"
import {Poster} from "./Apparatus/Poster"

import TubeStand from "./Apparatus/TubeStand/TubeStand"
import Shelf from "./Apparatus/Shelf/Shelf"
import Table from "./Apparatus/Table/Table"
import PipetteRack from "./Apparatus/PipetteRack/PipetteRack"

import "./style.scss";

export class ProtocolScene extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      components: []
    };
  }
  componentDidMount() {
    this.doCompPart(this.props.apparatus);
  }

  doCompPart = data => {
    let groupArr = [];
    let compArr = [];

    Object.keys(data).forEach((key, index) => {
      compArr = [];
      data[key].components.forEach((comp, index) => {
        compArr.push(this.buildComponent(comp, index, data[key].position));
      });
      groupArr.push(
        <Group key={index} components={compArr} position={data[key].position} />
      );
    });

    this.setState({
      components: groupArr
    });
  };

  buildComponent = (data, index, position) => {
    switch (data.component) {

      case "Table":
        return <Table key={index} position={position} id={data.props.id} />;

      case "Shelf":
        return <Shelf key={index} position={position} id={data.props.id} />;

      case "Pipette Rack":
        return <PipetteRack key={index} position={position} id={data.props.id} />;

      case "Tube Stand":
        return <TubeStand key={index} position={position} id={data.props.id} />;

      case "Poster":
        return <Poster defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Ice Bucket":
        return <IceBucket defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Thermocycler":
        return <Thermocycler defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Trash":
        return <Trash defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Tip Box":
        return <TipBox defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Solution":
        return <Solution defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      case "Pipette":
        return <Pipette defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      // case "Microcentrifuge":
      //   return <Microcentrifuge defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      // case "Heat Block":
      //   return <HeatBlock defaultProps={data.props} key={index} position={position} id={data.props.id} />;

      // case "Tube":
      //     return <Tubes key={index} position={position} id={data.props.id} />;

      default:
        break;
    }
  };

  render() {
    return this.state.components
  }
}

ProtocolScene.propTypes = {
  optionHolders: PropTypes.array.isRequired,
};
